import { Component, OnInit } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { ActivatedRoute, Router } from '@angular/router';
import { DeviceDetectorService } from 'ngx-device-detector';
import { LocalStorageService } from 'angular-2-local-storage';
import { IDateRangePickerOptions } from 'ngx-daterange';
import { FormBuilder, Validators } from '@angular/forms';

import { ToastrService } from 'ngx-toastr';
import { IDropdownSettings } from 'ng-multiselect-dropdown';
import { environment } from 'src/environments/environment';
import { service_methods6 } from '../admin/service_methods6';

@Component({
  selector: 'app-changepassword',
  templateUrl: './changepassword.component.html',
  styleUrls: ['./changepassword.component.css']
})
export class ChangepasswordComponent implements OnInit {
  initialValue: any;
  show1: boolean = false;
  show2: boolean = false;
  show3: boolean = false;
  opd = 0;
  formGroup: any;
  password: string;
  msg: any;


  constructor(private fb: FormBuilder,private obj: service_methods6, private route: Router, private deviceService: DeviceDetectorService,
    private Toaster: ToastrService, private Localstorage: LocalStorageService, private aroute: ActivatedRoute) {
  }

  ngOnInit(): void {
    this.initialValue = this.formmaster.value;
  }

  public formmaster = this.fb.group({
    userid: [this.Localstorage.get("userid"), [Validators.required]],
    currentpassword: ['', [Validators.required]],
    newpassword: ['', [Validators.required,Validators.minLength(8), Validators.maxLength(20), Validators.pattern('^[a-zA-Z0-9!@#$%^&*()]*$')]],
    confirmpassword: ['', [Validators.required,Validators.minLength(8), Validators.maxLength(20), Validators.pattern('^[a-zA-Z0-9!@#$%^&*()]*$')]]

  });

  onClick(type) {
    if (type == 1) {
      this.show1 = !this.show1;
    }
    if (type == 2) {
      this.show2 = !this.show2;
    }
    if (type == 3) {
      this.show3 = !this.show3;
    }
  }

  // For change password
  changePassword() {
    this.formmaster.markAllAsTouched();
    if (this.formmaster.valid) {
      var Data = {
        "userid": this.formmaster.get("userid").value,
        "currentpassword": this.formmaster.get("currentpassword").value,
        "newpassword": this.formmaster.get("newpassword").value
        // ,
        // "username": this.formmaster.get("username").value?this.formmaster.get('username').value:''
      };

      let headers = new HttpHeaders({
        'Content-Type': 'application/json'
      });
      let options = {
        headers: headers
      }
      let body = JSON.stringify(Data);
      this.obj._commonpost("change_password",body).then((data) => {
            if (data[0].success == 1) {
              this.Toaster.success(data[0].msg, "", { timeOut: 5000 });
              this.Reset();
              if (data[0].success == 1) {
                this.Toaster.success
              }

            } else if (data[0].success == 0) {
              this.Toaster.error(data[0].msg, "", { timeOut: 5000 });
            } else {
              this.Toaster.error(data[0].msg, "", { timeOut: 5000 });
            }
          },
          (error: any) => {
            this.Toaster.error("An error occurred while processing your request", "", { timeOut: 5000 });
          }
        );
    }
  }


  Reset() {
    this.formmaster.reset(this.initialValue);
  }
}
